import Vue from 'vue/dist/vue.js';
import Router from 'vue-router';
import DisplayCode from './components/DisplayCode.vue';
import CreateCode from './components/CreateCode.vue';
import UpdateCode from './components/UpdateCode.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: CreateCode,
    },
    {
      path: '/:key',
      name: 'key',
      component: DisplayCode,
    },
    {
      path: '/edit/:title/:key',
      name: 'edit',
      component: UpdateCode,
    },
  ]
});